import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../common/store/types';
import {
  InsuranceClaimFormModel,
  InsuranceClaimModel,
  InsuranceClaimStatusFlow,
  InsuranceClaimStatusHistoryModel,
} from './types';
import { Action as ViewAction } from '../view/types';
import { insuranceClaimActions } from './insurance-claim.actions';

export interface IInsuranceClaimState extends IState<InsuranceClaimModel> {
  getById: GenericState<InsuranceClaimModel>;
  getByUniqueId: GenericState<InsuranceClaimModel>;
  createInstance: GenericState<InsuranceClaimFormModel>;
  add: GenericState<InsuranceClaimModel>;
  update: GenericState<InsuranceClaimModel>;
  generateDocuments: GenericState<boolean>;
  requestValidation: GenericState<boolean>;
  validate: GenericState<boolean>;
  openDossierToTransmitter: GenericState<boolean>;
  openClaim: GenericState<boolean>;
  close: GenericState<boolean>;
  reopen: GenericState<boolean>;
  reject: GenericState<boolean>;
  getStatusHistory: GenericState<InsuranceClaimStatusHistoryModel>;
  updateStatusHistory: GenericState<InsuranceClaimStatusHistoryModel>;
  deleteStatusHistory: GenericState<boolean>;
  getStatusFlow: GenericState<InsuranceClaimStatusFlow[]>;
  getStatusActions: GenericState<ViewAction[]>;
}

export const insuranceClaimInitialState: IInsuranceClaimState = {
  getById: new GenericState<InsuranceClaimModel>(),
  getByUniqueId: new GenericState<InsuranceClaimModel>(),
  createInstance: new GenericState<InsuranceClaimFormModel>(),
  add: new GenericState<InsuranceClaimModel>(),
  update: new GenericState<InsuranceClaimModel>(),
  generateDocuments: new GenericState<boolean>(),
  requestValidation: new GenericState<boolean>(),
  validate: new GenericState<boolean>(),
  openDossierToTransmitter: new GenericState<boolean>(),
  openClaim: new GenericState<boolean>(),
  close: new GenericState<boolean>(),
  reopen: new GenericState<boolean>(),
  reject: new GenericState<boolean>(),
  getStatusHistory: new GenericState<InsuranceClaimStatusHistoryModel>(),
  updateStatusHistory: new GenericState<InsuranceClaimStatusHistoryModel>(),
  deleteStatusHistory: new GenericState<boolean>(),
  getStatusFlow: new GenericState<InsuranceClaimStatusFlow[]>(),
  getStatusActions: new GenericState<ViewAction[]>(),
};

const insuranceClaimReducers = [
  ...onApiCall<InsuranceClaimModel>(insuranceClaimActions.getById, 'getById'),
  ...onApiCall<InsuranceClaimModel>(
    insuranceClaimActions.getByUniqueId,
    'getByUniqueId',
  ),
  ...onApiCall<InsuranceClaimFormModel>(
    insuranceClaimActions.createInstance,
    'createInstance',
  ),
  ...onApiCall<InsuranceClaimModel>(insuranceClaimActions.add, 'add'),
  ...onApiCall<InsuranceClaimModel>(insuranceClaimActions.update, 'update'),
  ...onApiCall<boolean>(
    insuranceClaimActions.generateDocuments,
    'generateDocuments',
  ),
  ...onApiCall<boolean>(
    insuranceClaimActions.requestValidation,
    'requestValidation',
  ),
  ...onApiCall<boolean>(insuranceClaimActions.validate, 'validate'),
  ...onApiCall<boolean>(
    insuranceClaimActions.openDossierToTransmitter,
    'openDossierToTransmitter',
  ),
  ...onApiCall<boolean>(insuranceClaimActions.openClaim, 'openClaim'),
  ...onApiCall<boolean>(insuranceClaimActions.close, 'close'),
  ...onApiCall<boolean>(insuranceClaimActions.reopen, 'reopen'),
  ...onApiCall<boolean>(insuranceClaimActions.reject, 'reject'),
  ...onApiCall<InsuranceClaimStatusHistoryModel>(
    insuranceClaimActions.getStatusHistory,
    'getStatusHistory',
  ),
  ...onApiCall<InsuranceClaimStatusHistoryModel>(
    insuranceClaimActions.updateStatusHistory,
    'updateStatusHistory',
  ),
  ...onApiCall<boolean>(
    insuranceClaimActions.deleteStatusHistory,
    'deleteStatusHistory',
  ),
  ...onApiCall<InsuranceClaimStatusFlow[]>(
    insuranceClaimActions.getStatusFlow,
    'getStatusFlow',
  ),
  ...onApiCall<ViewAction[]>(
    insuranceClaimActions.getStatusActions,
    'getStatusActions',
  ),
];

export const insuranceClaimReducer = createReducer(
  insuranceClaimInitialState,
  ...insuranceClaimReducers,
) as ActionReducer<IInsuranceClaimState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return insuranceClaimReducer(state, action);
}
